import { render, staticRenderFns } from "./transactionOtp.vue?vue&type=template&id=d116de66&"
import script from "./transactionOtp.vue?vue&type=script&lang=js&"
export * from "./transactionOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports